"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import Account from "../../api/account";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import InvoiceInputFields from "./invoice_input_fields";
import {
  cleanedInvoiceFields,
  initialInvoiceFieldsState,
  invoiceFieldsStateUpdate
} from "./invoice_fields_state";
import LoadAssignerProgress, {
  getLoadAssignerProgressItems
} from "./load_assigner_progress";
import LoadTable from "./load_table";
import LoadSearchArea from "./load_search_area";
import DocumentExceptionArea from "./document_exception_area";
import CarrierChooser from "./carrier_chooser";
import CarrierInvoiceChooser from "./carrier_invoice_chooser";
import DocumentTitle from "../../components/document_title";
import DisablingButton from "../../components/disabling_button";
import reactUtils from "../../react_utils";
var bem = reactUtils.makeBem("document-group-editor");
function hasGuessedLoadFor(props) {
  return props.loads.guessed.length > 0 || props.loads.selected;
}
function createLoadsInHubtran() {
  return Account.currentSettings().create_loads_in_hubtran;
}
function creatingLoad(isNew) {
  return isNew === true && createLoadsInHubtran();
}
function possibleCarrierChooserNumbering() {
  if (!createLoadsInHubtran()) {
    return /* @__PURE__ */ jsx("span", { className: "paragraph__possible-select-load-text-numbering", children: /* @__PURE__ */ jsx("strong", { children: "2." }) });
  }
}
function carrierID(props, isNew) {
  if (creatingLoad(isNew)) {
    return props.selectedCarrierID || props.documentBatch.single_carrier && props.documentBatch.carrier_id || null;
  } else {
    return props.selectedCarrierID;
  }
}
function showAssignLoadsContent(props, state) {
  return (!state.showExceptions || state.showExceptions && activeExceptions(props).length > 0) && !state.recentlyResolved;
}
function assignLoadsHeader(props) {
  var selectedLoad = props.loads.selectedLoad;
  var text = "Assign Load to This Document Group";
  if (selectedLoad && !selectedLoad.load.load_is_auto_confirmed) {
    return /* @__PURE__ */ jsx("h3", { children: text });
  } else if (!selectedLoad) {
    return /* @__PURE__ */ jsx("h3", { children: text });
  }
}
function userCreatedLoadExists(props) {
  return !!_.findWhere(
    _.map(props.loads.guessed, (load) => load.load),
    { source_system: "hubtran" }
  );
}
function guessedLoads(props) {
  return _.reject(props.loads.guessed, (load) => {
    return load.load.source_system == "hubtran";
  });
}
function possibleSelectLoadTextNumbering(props) {
  if (props.multiCarrier) {
    return /* @__PURE__ */ jsx("span", { className: "paragraph__possible-select-load-text-numbering", children: /* @__PURE__ */ jsx("strong", { children: "1." }) });
  }
}
function autoConfirmedLoadHeader(props) {
  return /* @__PURE__ */ jsx(
    AutoConfirmedLoadHeader,
    {
      carrierInvoice: null,
      load: props.loads.selectedLoad
    }
  );
}
function loadsNotFromEmailCarrier(props, loadState) {
  return !!(props.email.carrier_id && loadState.load.carrier_id !== props.email.carrier_id);
}
function possibleNonMatchingCarrierWarning(props, state) {
  if (!state.showSearch && _.find(
    guessedLoads(props),
    (loadState) => loadsNotFromEmailCarrier(props, loadState)
  )) {
    return /* @__PURE__ */ jsx("div", { className: "alert-box--caution", children: /* @__PURE__ */ jsxs("span", { children: [
      "At least one of the following loads is assigned to a",
      " ",
      Account.carrierTermLower(),
      " that does not match the",
      " ",
      Account.carrierTermLower(),
      " assigned to this email."
    ] }) });
  }
}
function carrierChooser(props) {
  if ((props.loads.selected || createLoadsInHubtran()) && !props.documentBatch.single_carrier) {
    return /* @__PURE__ */ jsxs("div", { className: "load-assigner__carrier-chooser", children: [
      possibleMultipleGuessedCarriersNotification(props),
      /* @__PURE__ */ jsxs("h6", { children: [
        possibleCarrierChooserNumbering(),
        "Select a ",
        Account.carrierTermLower(),
        " for this invoice:"
      ] }),
      /* @__PURE__ */ jsx(
        CarrierChooser,
        {
          carrierGuesses: props.carrierGuesses(),
          allowIndexingCustomerOnlyDocuments: isIndexCustomerOnlyDocsEnabled(
            props
          ),
          state: props.carrierChooserState,
          onUpdate: props.onCarrierChooserUpdate
        }
      )
    ] });
  }
}
function selectedLoadIsUserCreated(props) {
  var selectedLoad = props.loads.selectedLoad;
  return !_.isEmpty(selectedLoad) && selectedLoad.load.source_system === "hubtran";
}
function nonUserCreatedLoadSelected(props) {
  return props.loads.selected && !selectedLoadIsUserCreated(props);
}
function guessedLoadsContent(props, state) {
  if (!state.showSearch) {
    return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      LoadTable,
      {
        items: guessedLoads(props),
        highlightChanged: props.highlightReference,
        selectedLoadStateId: props.loads.selected,
        highlightedLoads: _.pluck(guessedLoads(props), "id"),
        loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(props, loadState),
        onSelectionChange: props.setSelectedLoad
      }
    ) });
  }
}
function possibleMultipleGuessedCarriersNotification(props) {
  if (props.documentGroup.multiple_guessed_carriers) {
    return /* @__PURE__ */ jsxs("div", { className: "alert-box--progress", children: [
      "TriumphPay Audit was unable to automatically assign a",
      " ",
      Account.carrierTermLower(),
      " to this group because multiple different",
      " ",
      Account.carrierTermLower(),
      "s or multiple matching",
      " ",
      Account.carrierTermLower(),
      "s with similar names were detected in the documents."
    ] });
  }
}
function activeExceptions(props, givenProps) {
  const effectiveProps = givenProps ? givenProps : props;
  return _.reject(
    effectiveProps.documentGroup.exception_events,
    _.property("resolved_at")
  );
}
function isIndexCustomerOnlyDocsEnabled(props) {
  return Account.currentSettings().allow_indexing_customer_only_documents && props.documentBatch.customer_only;
}
function showInvoiceChooserForCustomerOnlyDocs(props) {
  return props.loads.selected && props.assignCustomerOnlyDocuments && isIndexCustomerOnlyDocsEnabled(props);
}
const NEW_INVOICE = { id: "new" };
export default class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "invoiceInputFields", () => {
      if (!Account.currentSettings().index_audit_split_enabled) {
        return null;
      }
      return /* @__PURE__ */ jsx(
        InvoiceInputFields,
        {
          getSelectedInvoiceForGroup: this.props.getSelectedInvoiceForGroup,
          onFieldChange: this.onInvoiceFieldChange,
          sourceInvoiceAmount: this.state.source_invoice_amount,
          sourceInvoiceNumber: this.state.source_invoice_number,
          ref: "invoiceInputFields"
        }
      );
    });
    __publicField(this, "onInvoiceFieldChange", (field, value) => {
      this.setState({ [field]: value, [`${field}_edited`]: true });
    });
    __publicField(this, "invoiceDataEntered", () => {
      const fields = cleanedInvoiceFields(this.state);
      return !!(fields.source_invoice_amount && fields.source_invoice_number);
    });
    __publicField(this, "focusNextField", () => {
      if (this.refs.invoiceInputFields) {
        this.refs.invoiceInputFields.focusNextField();
      }
    });
    // STATE
    __publicField(this, "assignLoad", (isNew) => {
      let selectedLoad;
      if (creatingLoad(isNew)) {
        selectedLoad = "new";
      } else {
        selectedLoad = this.props.loads.selected;
      }
      var isFirstLoad = !this.props.currentlyAssignedInvoiceForGroup;
      const carrierInvoice = {};
      const fields = cleanedInvoiceFields(this.state);
      ["source_invoice_number", "source_invoice_amount"].forEach((field) => {
        if (fields[field]) {
          carrierInvoice[field] = fields[field];
        }
      });
      const assignCustomerOnlyDocuments = this.props.assignCustomerOnlyDocuments;
      this.setState({ saving: true });
      this.props.assignCurrentGroupToLoadAndInvoiceId(
        selectedLoad,
        this.props.getSelectedInvoiceForGroup(NEW_INVOICE).id,
        carrierInvoice,
        carrierID(this.props, isNew),
        isFirstLoad,
        assignCustomerOnlyDocuments,
        this.props.shipmentDocumentSelections
      );
    });
    __publicField(this, "toggleExceptions", () => {
      this.setState({ showExceptions: !this.state.showExceptions });
    });
    __publicField(this, "showSearch", () => {
      this.setState({ showSearch: true });
    });
    __publicField(this, "cancelSearch", () => {
      this.setState({ showSearch: false });
      this.focusNextField();
    });
    __publicField(this, "carrierSelected", (carrier) => {
      this.setState({ carrier });
    });
    __publicField(this, "assignLoadsContent", () => {
      if (showAssignLoadsContent(this.props, this.state)) {
        return /* @__PURE__ */ jsxs("div", { children: [
          assignLoadsHeader(this.props),
          this.selectLoadText(),
          this.documentGroup(),
          this.possibleExceptionsLink()
        ] });
      }
    });
    __publicField(this, "documentGroup", () => {
      return /* @__PURE__ */ jsxs("div", { className: bem("__group"), children: [
        /* @__PURE__ */ jsx("div", { className: bem("__group-title"), children: this.props.group.name }),
        possibleNonMatchingCarrierWarning(this.props, this.state),
        this.loadSearchArea(),
        guessedLoadsContent(this.props, this.state)
      ] });
    });
    __publicField(this, "possibleExceptionsLink", () => {
      if (!this.state.showExceptions) {
        return /* @__PURE__ */ jsxs("p", { className: "load-assigner__report-problem", children: [
          "Still issues?",
          " ",
          /* @__PURE__ */ jsx("a", { onClick: this.toggleExceptions, children: "Create an exception" })
        ] });
      }
    });
    __publicField(this, "selectLoadText", () => {
      if (!this.state.showSearch) {
        var selectedLoad = this.props.loads.selectedLoad;
        var text = selectedLoad && selectedLoad.load.load_is_auto_confirmed ? autoConfirmedLoadHeader(this.props) : "Select a load from the loads we identified in the documents. ";
        return /* @__PURE__ */ jsx("div", { className: "paragraph", children: /* @__PURE__ */ jsxs("span", { children: [
          possibleSelectLoadTextNumbering(this.props),
          text,
          "Not the right ones?",
          " ",
          /* @__PURE__ */ jsx("a", { onClick: this.showSearch, children: "Search for another one" }),
          "."
        ] }) });
      }
    });
    __publicField(this, "progressArea", () => {
      if (this.state.tab !== "exception") {
        return /* @__PURE__ */ jsx("div", { className: "load-assigner__save-buttons", children: /* @__PURE__ */ jsxs("div", { className: "load-assigner__save-buttons-inner", children: [
          this.invoiceInputFields(),
          carrierChooser(this.props),
          this.invoiceChooser(),
          this.possibleCreateLoadButton(),
          this.possibleMessageOrSave()
        ] }) });
      }
    });
    __publicField(this, "invoiceChooser", () => {
      if (nonUserCreatedLoadSelected(this.props) && this.props.selectedCarrierID || showInvoiceChooserForCustomerOnlyDocs(this.props)) {
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          CarrierInvoiceChooser,
          {
            loadID: this.props.loads.selectedLoad.load.load_id,
            invoicesForGroup: this.props.invoicesForGroup,
            initialInvoiceId: _.first(
              _.compact(
                _.pluck(this.props.group.documents, "carrier_invoice_id")
              )
            ),
            selectedInvoice: this.props.getSelectedInvoiceForGroup(NEW_INVOICE),
            carrierID: this.props.selectedCarrierID,
            group: this.props.group,
            newInvoice: NEW_INVOICE,
            currentlyAssignedInvoice: this.props.currentlyAssignedInvoiceForGroup,
            invoiceSelected: this.props.setSelectedInvoiceForGroup
          }
        ) });
      }
    });
    __publicField(this, "possibleCreateLoadButton", () => {
      if (createLoadsInHubtran() && !nonUserCreatedLoadSelected(this.props)) {
        if (!this.props.selectedCarrierID) {
          return /* @__PURE__ */ jsx("div", { className: "load-assigner__possible-create-load-button", children: /* @__PURE__ */ jsxs("button", { className: "button--disabled", disabled: true, children: [
            "Select a ",
            Account.carrierTermLower(),
            " to continue"
          ] }) });
        }
        if (userCreatedLoadExists(this.props)) {
          var buttonText = "Edit Existing Created Load";
        } else {
          var buttonText = "Create a Load";
        }
        return /* @__PURE__ */ jsx("div", { className: "load-assigner__possible-create-load-button", children: /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabledText: buttonText,
            className: "button--progress",
            disabled: this.state.saving,
            onClick: _.partial(this.assignLoad, true),
            children: buttonText
          }
        ) });
      }
    });
    __publicField(this, "possibleMessageOrSave", () => {
      if (!createLoadsInHubtran() || nonUserCreatedLoadSelected(this.props)) {
        return this.messageOrSave();
      }
    });
    __publicField(this, "messageOrSave", () => {
      let button;
      if (this.state.saving) {
        button = /* @__PURE__ */ jsx("button", { disabled: true, children: "Saving..." });
      } else if (this.props.loads.selected && this.props.selectedCarrierID && this.props.getSelectedInvoiceForGroup(NEW_INVOICE)) {
        let buttonText = "Continue";
        if (Account.indexAuditSplitEnabled()) {
          buttonText = "Submit";
        }
        button = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("button", { className: "button--progress ", onClick: this.assignLoad, children: buttonText }) });
      } else if (this.props.loads.selected && this.props.assignCustomerOnlyDocuments && isIndexCustomerOnlyDocsEnabled(this.props)) {
        let buttonText = "Continue assigning customer only documents";
        if (Account.indexAuditSplitEnabled()) {
          buttonText = "Submit customer only documents";
        }
        button = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("button", { className: "button--progress ", onClick: this.assignLoad, children: buttonText }) });
      } else if (this.props.loads.selected && this.props.selectedCarrierID) {
        button = /* @__PURE__ */ jsx("button", { className: "button--disabled", disabled: true, children: "Select an invoice option to continue" });
      } else if (this.props.loads.selected) {
        button = /* @__PURE__ */ jsxs("button", { className: "button--disabled", disabled: true, children: [
          "Select a ",
          Account.carrierTermLower(),
          " to continue"
        ] });
      } else {
        button = /* @__PURE__ */ jsx("button", { className: "button--disabled", disabled: true, children: "Select a load to continue" });
      }
      const progressItems = getLoadAssignerProgressItems(
        this.props.loads.selectedLoad,
        this.props.documentBatch,
        this.props.documentGroup,
        this.invoiceDataEntered(),
        this.props.shipmentDocumentSelections,
        false,
        this.props.documentLoadRelationships
      );
      return /* @__PURE__ */ jsx("div", { className: bem("__actions"), children: /* @__PURE__ */ jsx(LoadAssignerProgress, { content: button, items: progressItems }) });
    });
    __publicField(this, "recentlyResolved", () => {
      this.setState({ recentlyResolved: true });
    });
    __publicField(this, "closeExceptions", () => {
      this.setState({ recentlyResolved: false, showExceptions: false });
    });
    __publicField(this, "reportProblemContent", () => {
      if (this.state.showExceptions || !this.state.showExceptions && this.state.recentlyResolved) {
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: "load-assigner__document-exception-area panel",
            ref: "problemContent",
            children: /* @__PURE__ */ jsx(
              DocumentExceptionArea,
              {
                closeExceptions: this.closeExceptions,
                location: this.props.location,
                recentlyResolved: this.recentlyResolved,
                hasMore: this.props.hasMore,
                documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
                model: this.props.model,
                email: this.props.email,
                carrier: this.props.carrier,
                selectedLoad: this.props.loads.selectedLoad,
                documentGroup: this.props.documentGroup,
                exceptionResolver: this.props.exceptionResolver,
                exceptionCreator: this.props.exceptionCreator,
                exceptionUpdater: this.props.exceptionUpdater,
                exceptions: activeExceptions(this.props),
                scrollUp: this.scrollUp,
                onCancel: this.toggleExceptions
              }
            )
          }
        );
      }
    });
    __publicField(this, "loadSearchArea", () => {
      if (this.state.showSearch) {
        return /* @__PURE__ */ jsx(
          LoadSearchArea,
          {
            loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(this.props, loadState),
            carrier: this.props.carrier,
            selectedLoadStateId: this.props.loads.selected,
            highlightedLoads: _.pluck(guessedLoads(this.props), "id"),
            searcher: this.props.searcher,
            onSelectionChange: this.props.setSelectedLoad,
            onCancel: this.cancelSearch,
            multiCarrier: this.props.multiCarrier,
            highlightReference: this.props.highlightReference
          }
        );
      }
    });
    __publicField(this, "scrollUp", () => {
      const container = ReactDOM.findDOMNode(this.refs.problemContent);
      container.scrollIntoView();
    });
    const hasGuessedLoad = hasGuessedLoadFor(props);
    this.state = __spreadProps(__spreadValues({
      showExceptions: _.first(activeExceptions(props)),
      showSearch: !hasGuessedLoad,
      showGuessed: hasGuessedLoad
    }, initialInvoiceFieldsState(props)), {
      prevGroup: props.group,
      prevSaving: props.saving
    });
  }
  static getDerivedStateFromProps(props, state) {
    let update = invoiceFieldsStateUpdate(
      props,
      state
    );
    if (props.group !== state.prevGroup) {
      const hasGuessedLoad = hasGuessedLoadFor(props);
      update = __spreadProps(__spreadValues({}, update), {
        prevGroup: props.group,
        showExceptions: _.first(activeExceptions(props)),
        showSearch: !hasGuessedLoad,
        showGuessed: hasGuessedLoad
      });
    }
    if (props.saving !== state.prevSaving) {
      update = __spreadProps(__spreadValues({}, update), { prevSaving: props.saving, saving: props.saving });
    }
    return update;
  }
  componentDidMount() {
    if (hasGuessedLoadFor(this.props)) {
      this.focusNextField();
    }
  }
  // RENDER
  render() {
    return /* @__PURE__ */ jsx(DocumentTitle, { title: "TriumphPay Audit \u2013 Assign Loads", children: /* @__PURE__ */ jsxs("div", { className: "load-assigner__root", children: [
      /* @__PURE__ */ jsxs("div", { className: "load-assigner__scrollable-area", children: [
        this.reportProblemContent(),
        this.assignLoadsContent()
      ] }),
      this.progressArea()
    ] }) });
  }
}
